import KeyDates from "./charts/KeyDates"
import RecentNotes from "./charts/RecentNotes"
import LastFileLoad from "./charts/LastFileLoad"
import SyncPerformance from "./charts/SyncPerformance"

const Management = ({ data }: { data: any }) => {
  return (
    <>
      <div className="mon-manage">
        {/*<div*/}
        {/*  className="border border-2 rounded border-solid"*/}
        {/*  style={{ minHeight: 164 }}*/}
        {/*>*/}
        {/*  <Alerts />*/}
        {/*</div>*/}
        <div className="border border-2 rounded border-solid">
          <SyncPerformance />
        </div>
        <div className="border border-2 rounded border-solid">
          <KeyDates />
        </div>
        <div className="border border-2 rounded border-solid">
          <LastFileLoad data={data} />
        </div>
        <div className="border border-2 rounded border-solid">
          <RecentNotes />
        </div>
      </div>
    </>
  )
}

export default Management